(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    const copy = JSON.parse($('[data-playmat-copy]').textContent);
    const config = JSON.parse($('[data-playmat-config]').textContent);
    const money = cents => new Intl.NumberFormat(config.locale, {style:'currency', currency:config.currency}).format(cents/100);
    const form = $('.pm-form');
    const quoteForm = $('.pm-contact');
    const file = $('[data-artwork]');
    const link = $('[data-art-link]');
    const error = $('[data-error]');
    let objectUrl, submitting = false;
    const custom = () => $('[name="size_mode"]:checked').value === 'custom';
    const thickness = () => $('[name="id"]:checked');
    const layout = () => $('[name="properties[Layout]"]:checked').value;
    function update() {
      const isCustom = custom(), variant = thickness(), hasZones = layout() === 'Add Game Zones';
      $('[data-custom-dimensions]').hidden = !isCustom;
      $('[data-quote-form]').hidden = !isCustom;
      $('[data-file-area]').hidden = isCustom;
      $('[data-quote-art]').hidden = !isCustom;
      file.disabled = isCustom;
      $('[data-game-field]').hidden = !hasZones;
      $('[data-game]').disabled = !hasZones;
      $('[data-game]').required = hasZones;
      const sizeText = isCustom ? $('[data-width]').value + ' × ' + $('[data-height]').value + ' inches' : copy.dimensions;
      $('[data-summary-size]').textContent = sizeText;
      $('[data-summary-thickness]').textContent = variant ? variant.dataset.thickness : copy.unavailable;
      $('[data-summary-layout]').textContent = layout() + (hasZones && $('[data-game]').value ? ' · ' + $('[data-game]').value : '');
      $('[data-summary-art]').textContent = !isCustom && file.files.length ? file.files[0].name : link.value ? copy.art_link : copy.preview_hint;
      const price = variant ? Number(variant.dataset.price) : 3499;
      $('[data-total]').textContent = isCustom ? copy.quote_price : money(price);
      $('[data-mobile-total]').textContent = isCustom ? copy.quote_price : money(price);
      $('[data-mobile-label]').textContent = isCustom ? copy.custom : copy.subtotal;
      $('[data-base-price]').textContent = isCustom ? '—' : money(3499);
      $('[data-upgrade-price]').textContent = isCustom ? '—' : money(price - 3499);
      $('[data-summary-note]').textContent = isCustom ? copy.quote_note : copy.taxes;
      $('[data-preview-zones]').hidden = !hasZones;
      const width = isCustom ? Number($('[data-width]').value) : 24;
      const height = isCustom ? Number($('[data-height]').value) : 14;
      $('[data-mat]').style.aspectRatio = width > 0 && height > 0 ? width + '/' + height : '24/14';
      $$('[data-cart], [data-buy], [data-mobile-cart]').forEach(button => {
        button.hidden = isCustom;
        button.disabled = isCustom || !variant || variant.dataset.available !== 'true';
      });
      $$('[data-quote-link], [data-mobile-quote]').forEach(button => button.hidden = !isCustom);
      $('[data-clear-file]').hidden = !file.files.length;
    }
    function artworkValid(isQuote) {
      if ((!isQuote && file.files.length) || link.value.trim()) return true;
      error.textContent = copy.required_art;
      link.focus();
      return false;
    }
    function clearImage() {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = undefined;
      $('[data-preview-image]').hidden = true;
      $('[data-preview-image]').removeAttribute('src');
      $('[data-preview-empty]').hidden = false;
    }
    file.addEventListener('change', () => {
      error.textContent = '';
      clearImage();
      const asset = file.files[0];
      if (asset && (!/\.(png|jpe?g|pdf)$/i.test(asset.name) || asset.size > 20*1024*1024)) {
        file.value = '';
        error.textContent = copy.bad_file;
      } else if (asset && /\.(png|jpe?g)$/i.test(asset.name)) {
        objectUrl = URL.createObjectURL(asset);
        $('[data-preview-image]').src = objectUrl;
        $('[data-preview-image]').hidden = false;
        $('[data-preview-empty]').hidden = true;
      }
      update();
    });
    $('[data-clear-file]').addEventListener('click', () => { file.value = ''; clearImage(); update(); });
    root.addEventListener('input', update);
    root.addEventListener('change', update);
    form.addEventListener('submit', event => {
      error.textContent = '';
      if (custom() || submitting || !thickness() || thickness().dataset.available !== 'true' || !artworkValid(false)) {
        event.preventDefault();
        if (!custom() && (!thickness() || thickness().dataset.available !== 'true')) error.textContent = copy.unavailable;
        return;
      }
      submitting = true;
    });
    quoteForm.addEventListener('submit', event => {
      error.textContent = '';
      const width = $('[data-width]'), height = $('[data-height]');
      if (!custom() || !width.reportValidity() || !height.reportValidity() || !link.reportValidity() || !artworkValid(true) || !$('[data-rights]').reportValidity() || !$('[data-game]').reportValidity()) {
        event.preventDefault();
        return;
      }
      $('[data-quote-body]').value = [
        'Custom-size playmat quote', 'Dimensions: ' + width.value + ' × ' + height.value + ' inches',
        'Thickness: ' + thickness().dataset.thickness, 'Layout: ' + layout(),
        'Game: ' + (layout() === 'Add Game Zones' ? $('[data-game]').value : 'No zones requested'),
        'Artwork link: ' + link.value, 'Artwork permission: Confirmed',
        'Instructions: ' + $('[data-instructions]').value, 'Price to be quoted before payment.'
      ].join('\n');
    });
    $$('[data-quote-link], [data-mobile-quote]').forEach(button => button.addEventListener('click', () => {
      $('[data-quote-form]').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
      quoteForm.querySelector('input[type="text"]').focus({preventScroll:true});
    }));
    if (new URLSearchParams(location.search).get('contact_posted') === 'true') $('[name="size_mode"][value="custom"]').checked = true;
    update();
  }
  const load = () => document.querySelectorAll('[data-playmat-builder]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load); else load();
  document.addEventListener('shopify:section:load', load);
})();
